import React from 'react';
import Select from 'react-select';
import usaFlag from '../../images/products/us-flag.png';
import canadaFlag from '../../images/products/canada-flag.jpg';

export const style = {
   option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? 'red' : 'blue',
      padding: 2,
      width: 85
    }),
    control: () => ({
      // none of react-select's styles are passed to <Control />
      width: 85,
      border: '1px solid black',
      display: 'flex',
      marginBottom: '.5rem',
      disabled: true
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = 'opacity 300ms';
  
      return { ...provided, opacity, transition };
    }
}

const SelectCurrency = props => {
   // const [open, setOpen] = useState(false);

   const labelStyle = {
      marginRight: '.5rem'
   }

   const flagStyle = {
      width: '1.8rem',
      height: '1rem',
      marginTop: '.5rem',
      marginRight: '.5rem'
   }

   const options = [
      {value: 'USD', label: 'USD'},
      {value: 'CAD', label: 'CAD'}
   ]

   const alt = props.currency === 'USD' ? 'American Flag' : 'Canadian Flag';
   
   return (
      <div className="pl-select d-flex">
         <label style={labelStyle} htmlFor="select-currency">Prices in:</label>
         <img src={props.currency === 'USD' ? usaFlag : canadaFlag} alt={alt} style={flagStyle}/>
         <Select  id="select-currency" onChange={props.setCurrency} value={props.currency} options={options} placeholder={props.currency} styles={style}/>
      </div>
   )
}

export default SelectCurrency
